var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var TagIconWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 0.125rem;\n  margin-top: ", ";\n"], ["\n  margin-right: 0.125rem;\n  margin-top: ", ";\n"])), function (_a) {
    var size = _a.size;
    return (size === 'regular' ? '0' : '-1px');
});
var templateObject_1;
